<template>
  <section :class="embedded ? 'py-0' : 'bg-[#F6EBDC] py-16'">
    <div :class="embedded ? 'w-full' : 'w-full grid lg:grid-cols-[2fr_1fr] gap-0 bg-[#EDDCC4]'">
      <!-- FORM -->
      <div :class="embedded ? 'p-0' : 'p-12 lg:p-16'">
        <h2 class="text-[38px] font-black italic uppercase text-[#111] mb-10">{{ t('productManage.dashboard.menu.changePassword') }}</h2>

        <template v-if="!done">
        <form @submit.prevent="handleSubmit" class="space-y-5 max-w-[760px]">
          <!-- Current password -->
          <div class="max-w-[520px]">
            <div class="relative">
              <input ref="cur" v-model="currentPassword" :type="showCur ? 'text' : 'password'" autocomplete="current-password" required
                     :placeholder="t('placeholders.password')"
                     class="w-full h-12 bg-transparent px-1 pr-12 border-0 border-b-2 border-[#d4cfc5] text-black placeholder:text-[#8c857a]
                    focus:outline-none focus:border-black" />
              <button type="button" @click="toggleCur" @mousedown.prevent @touchstart.prevent
                      class="absolute right-0 top-1/2 -translate-y-1/2 h-10 w-10 grid place-items-center text-[#666] hover:text-[#111] focus:outline-none"
                      :aria-pressed="showCur" :title="showCur ? t('aria.hidePassword') : t('aria.showPassword')">
                <svg v-if="showCur" class="w-5 h-5" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
                  <path d="M1 12s4-7 11-7 11 7 11 7-4 7-11 7-11-7-11-7z"/>
                  <circle cx="12" cy="12" r="3"/>
                </svg>
                <svg v-else class="w-5 h-5" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
                  <path d="M17.94 17.94A10.94 10.94 0 0 1 12 19c-7 0-11-7-11-7a21.77 21.77 0 0 1 5.06-5.94"/>
                  <path d="M1 1l22 22"/>
                  <path d="M10.58 10.58a3 3 0 0 0 4.24 4.24"/>
                </svg>
              </button>
            </div>
          </div>
          <!-- New password -->
          <div class="max-w-[520px]">
            <div class="relative">
              <input ref="pass1" v-model="password" :type="showNew ? 'text' : 'password'" autocomplete="new-password" required
                     @input="passwordTouched = true" @blur="passwordTouched = true"
                     :placeholder="t('placeholders.newPassword')"
                     :aria-invalid="!passwordValid && passwordTouched"
                     :class="[
                       'w-full h-12 bg-transparent px-1 pr-12 border-0 border-b-2 text-black placeholder:text-[#8c857a] focus:outline-none',
                       (passwordTouched && !passwordValid) ? 'border-[#b91c1c] focus:border-[#b91c1c]' : 'border-[#d4cfc5] focus:border-black'
                     ]" />
              <button type="button" @click="toggleNew" @mousedown.prevent @touchstart.prevent
                      class="absolute right-0 top-1/2 -translate-y-1/2 h-10 w-10 grid place-items-center text-[#666] hover:text-[#111] focus:outline-none"
                      :aria-pressed="showNew" :title="showNew ? t('aria.hidePassword') : t('aria.showPassword')">
                <svg v-if="showNew" class="w-5 h-5" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
                  <path d="M1 12s4-7 11-7 11 7 11 7-4 7-11 7-11-7-11-7z"/>
                  <circle cx="12" cy="12" r="3"/>
                </svg>
                <svg v-else class="w-5 h-5" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
                  <path d="M17.94 17.94A10.94 10.94 0 0 1 12 19c-7 0-11-7-11-7a21.77 21.77 0 0 1 5.06-5.94"/>
                  <path d="M1 1l22 22"/>
                  <path d="M10.58 10.58a3 3 0 0 0 4.24 4.24"/>
                </svg>
              </button>
            </div>
          </div>
          <!-- Confirm -->
          <div class="max-w-[520px]">
            <div class="relative">
              <input ref="pass2" v-model="password2" :type="showConf ? 'text' : 'password'" autocomplete="new-password" required
                     @input="password2Touched = true" @blur="password2Touched = true"
                     :placeholder="t('placeholders.confirmPassword')"
                     :aria-invalid="password2Touched && !passwordsMatch"
                     :class="[
                       'w-full h-12 bg-transparent px-1 pr-12 border-0 border-b-2 text-black placeholder:text-[#8c857a] focus:outline-none',
                       (password2Touched && !passwordsMatch) ? 'border-[#b91c1c] focus:border-[#b91c1c]' : 'border-[#d4cfc5] focus:border-black'
                     ]" />
              <button type="button" @click="toggleConf" @mousedown.prevent @touchstart.prevent
                      class="absolute right-0 top-1/2 -translate-y-1/2 h-10 w-10 grid place-items-center text-[#666] hover:text-[#111] focus:outline-none"
                      :aria-pressed="showConf" :title="showConf ? t('aria.hidePassword') : t('aria.showPassword')">
                <svg v-if="showConf" class="w-5 h-5" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
                  <path d="M1 12s4-7 11-7 11 7 11 7-4 7-11 7-11-7-11-7z"/>
                  <circle cx="12" cy="12" r="3"/>
                </svg>
                <svg v-else class="w-5 h-5" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
                  <path d="M17.94 17.94A10.94 10.94 0 0 1 12 19c-7 0-11-7-11-7a21.77 21.77 0 0 1 5.06-5.94"/>
                  <path d="M1 1l22 22"/>
                  <path d="M10.58 10.58a3 3 0 0 0 4.24 4.24"/>
                </svg>
              </button>
            </div>
          </div>

          <!-- Policy -->
          <div class="max-w-[520px] text-[14px] text-[#444]">
            <p>
              <strong>Wachtwoord‑eisen:</strong>
              Minimaal 12 tekens, met hoofdletter(s), kleine letter(s), cijfer(s) en speciaal teken. Mag geen (deel van) je naam of e‑mail bevatten en niet te voor de hand liggend zijn.
            </p>
            <ul class="mt-2 space-y-1">
              <li class="flex items-center gap-2" :class="password.length >= 12 ? 'text-[#166534]' : 'text-[#b91c1c]'">
                <span class="inline-block w-4 text-center">{{ password.length >= 12 ? '✓' : '•' }}</span>
                Minimaal 12 tekens
              </li>
              <li class="flex items-center gap-2" :class="/[A-Z]/.test(password) ? 'text-[#166534]' : 'text-[#b91c1c]'">
                <span class="inline-block w-4 text-center">{{ /[A-Z]/.test(password) ? '✓' : '•' }}</span>
                Ten minste één hoofdletter
              </li>
              <li class="flex items-center gap-2" :class="/[a-z]/.test(password) ? 'text-[#166534]' : 'text-[#b91c1c]'">
                <span class="inline-block w-4 text-center">{{ /[a-z]/.test(password) ? '✓' : '•' }}</span>
                Ten minste één kleine letter
              </li>
              <li class="flex items-center gap-2" :class="/\d/.test(password) ? 'text-[#166534]' : 'text-[#b91c1c]'">
                <span class="inline-block w-4 text-center">{{ /\d/.test(password) ? '✓' : '•' }}</span>
                Ten minste één cijfer
              </li>
              <li class="flex items-center gap-2" :class="/[^A-Za-z0-9]/.test(password) ? 'text-[#166534]' : 'text-[#b91c1c]'">
                <span class="inline-block w-4 text-center">{{ /[^A-Za-z0-9]/.test(password) ? '✓' : '•' }}</span>
                Ten minste één speciaal teken
              </li>
              <li class="flex items-center gap-2" :class="password2 ? (passwordsMatch ? 'text-[#166534]' : 'text-[#b91c1c]') : 'text-[#444]'">
                <span class="inline-block w-4 text-center">{{ password2 ? (passwordsMatch ? '✓' : '•') : '•' }}</span>
                Bevestiging komt overeen
              </li>
            </ul>
          </div>

          <!-- Submit -->
          <button type="submit" :disabled="isLoading || !formValid"
                  class="w-full max-w-[520px] h-12 bg-black text-white italic uppercase font-semibold tracking-wide disabled:opacity-60">
            <span v-if="isLoading">{{ t('buttons.saving') }}</span><span v-else>{{ t('buttons.savePassword') }}</span>
          </button>

          <!-- Messages -->
          <MmFlashMessage
            v-if="errorMessage"
            :message="errorMessage"
            type="error"
            @dismiss="errorMessage = ''"
          />
          <MmFlashMessage
            v-if="successMessage"
            :message="successMessage"
            type="success"
            :autoHideMs="6000"
            @dismiss="successMessage = ''"
          />
        </form>
        </template>
        <div v-else class="space-y-5 max-w-[760px]">
          <p class="max-w-[520px] text-[14px] text-[#166534]">
            {{ t('messages.passwordSaved') }}
          </p>
        </div>
      </div>

      <!-- INFO PANEL (alleen tonen buiten embedded) -->
      <aside v-if="!embedded" class="bg-gradient-to-br from-[#EA6730] to-[#F7941F] text-white p-10 lg:p-14 flex flex-col gap-8">
        <div>
          <h3 class="text-[26px] text-white italic uppercase mb-6 leading-tight">
            <span class="whitespace-pre-line">Samen maken we materialen beschikbaar</span>
          </h3>
          <ul class="space-y-4 text-[16px]">
            <li class="flex items-center gap-3">
              <svg class="w-5 h-5 flex-shrink-0" viewBox="0 0 24 24" aria-hidden="true">
                <path d="M4 12.5l6 6L20 6" fill="none" stroke="#ffffff" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
              <span>Impact met je donatie</span>
            </li>
            <li class="flex items-center gap-3">
              <svg class="w-5 h-5 flex-shrink-0" viewBox="0 0 24 24" aria-hidden="true">
                <path d="M4 12.5l6 6L20 6" fill="none" stroke="#ffffff" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
              <span>Help scholen en leerlingen</span>
            </li>
          </ul>
        </div>
        <button @click="$emit('backToLogin')" class="mt-4 w-full bg-white text-black italic uppercase font-extrabold h-12">
          {{ t('buttons.login') }}
        </button>
      </aside>
    </div>
  </section>
</template>

<script>
import WpApiClient from '../lib/wp-api.js'
import MmFlashMessage from './MmFlashMessage.vue'
import { t } from '../i18n'
export default {
  name: 'MmChangePassword',
  components: { MmFlashMessage },
  emits: ['backToLogin'],
  props: {
    embedded: { type: Boolean, default: false },
    t: { type: Function, default: t }
  },
  data(){
    return {
      currentPassword: '',
      password: '',
      password2: '',
      showCur: false,
      showNew: false,
      showConf: false,
      isLoading: false,
      errorMessage: '',
      successMessage: '',
      passwordTouched: false,
      password2Touched: false,
      done: false
    }
  },
  mounted(){ this.api = new WpApiClient(); },
  computed:{
    passwordValid(){
      const p = this.password || ''
      return p.length >= 12 && /[A-Z]/.test(p) && /[a-z]/.test(p) && /\d/.test(p) && /[^A-Za-z0-9]/.test(p)
    },
    passwordsMatch(){ return !!this.password && this.password2 === this.password },
    formValid(){
      const curOk = !!this.currentPassword
      return curOk && this.passwordValid && this.passwordsMatch
    }
  },
  methods:{
    t,
    toggleCur(){
      this.showCur = !this.showCur;
      this.$nextTick(() => { const el = this.$refs.cur; if (el && el.focus) { const pos = el.value ? el.value.length : 0; try { el.focus({ preventScroll: true }); } catch(_) { el.focus(); } try { el.setSelectionRange(pos, pos); } catch(_) {} } });
    },
    toggleNew(){
      this.showNew = !this.showNew;
      this.$nextTick(() => { const el = this.$refs.pass1; if (el && el.focus) { const pos = el.value ? el.value.length : 0; try { el.focus({ preventScroll: true }); } catch(_) { el.focus(); } try { el.setSelectionRange(pos, pos); } catch(_) {} } });
    },
    toggleConf(){
      this.showConf = !this.showConf;
      this.$nextTick(() => { const el = this.$refs.pass2; if (el && el.focus) { const pos = el.value ? el.value.length : 0; try { el.focus({ preventScroll: true }); } catch(_) { el.focus(); } try { el.setSelectionRange(pos, pos); } catch(_) {} } });
    },
    scrollToRef(refName){
      const el = this.$refs[refName];
      if (el && typeof el.scrollIntoView === 'function') {
        try { el.scrollIntoView({ behavior: 'smooth', block: 'center' }); } catch(_) { el.scrollIntoView(); }
      }
      if (el && typeof el.focus === 'function') {
        try { el.focus({ preventScroll: true }); } catch(_) { try { el.focus(); } catch(__) {} }
      }
    },
    findFirstInvalid(){
      if (!this.currentPassword) return 'cur'
      if (!this.passwordValid) return 'pass1'
      if (!this.passwordsMatch) return 'pass2'
      return ''
    },
    // mark fields as touched for live validation visuals
    markTouched(){
      if (!this.passwordTouched) this.passwordTouched = true
      if (!this.password2Touched) this.password2Touched = true
    },
    async handleSubmit(){
      this.markTouched()
      if (!this.formValid){
        const ref = this.findFirstInvalid();
        if (ref) this.scrollToRef(ref);
        return;
      }
      this.isLoading = true; this.errorMessage=''; this.successMessage='';
      try{
        let result = await this.api.postAjax('materiaal_change_password', {
          currentPassword: this.currentPassword,
          newPassword: this.password,
          confirmPassword: this.password2,
          nonce: (window.materiaalAjax && materiaalAjax.nonce) ? materiaalAjax.nonce : undefined,
        });

        // Automatische retry bij nonce error
        if (result && !result.ok && result.error && result.error.includes('nonce')) {
          const newNonce = await this.api.refreshNonce(false);
          if (newNonce) {
            result = await this.api.postAjax('materiaal_change_password', {
              currentPassword: this.currentPassword,
              newPassword: this.password,
              confirmPassword: this.password2,
              nonce: newNonce,
            });
          }
        }

        if (result && result.ok){
          // Update nonce voor volgende verzoeken (zoals login)
          if (result.newNonce && window.materiaalAjax) {
            window.materiaalAjax.nonce = result.newNonce;
          }
          // Toon alleen het gewenste succesbericht en verberg het formulier
          this.successMessage = this.t('messages.passwordSaved')
          this.done = true
          // Wis gevoelige waarden uit de state
          this.currentPassword = ''
          this.password = ''
          this.password2 = ''
        } else {
          this.errorMessage = (result && result.error) || 'Opslaan mislukt. Probeer het later opnieuw.'
        }
      }catch(e){ this.errorMessage = e?.message || 'Er ging iets mis.' }
      this.isLoading = false;
    }
  }
}
</script>
